module.exports = __webpack_public_path__ + "static/media/logomarca.5a47d29a.png";